export const SortBottomIcon = ({ active }) => {
  return (
    <svg
      width="8"
      height="4"
      viewBox="0 0 8 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 9.53674e-07L4 4L2.91409e-07 1.14416e-07"
        fill={`${active ? "#43BC98" : "#D6DCDA"}`}
      />
    </svg>
  );
};
